import { NumericalColumn, StringColumn, BooleanColumn } from 'baseui/data-table';

import { CustomDateColumn } from 'commons-ui';

export const COL_NAMES = {
	versionNumber: 'versionNumber',
	versionName: 'versionName',
	appPackageName: 'appPackageName',
	apkLinkUrl: 'apkLinkUrl',
	updatedAt: 'updatedAt',
	updatedBy: 'updatedBy',
	deployedOnWebsite: 'deployedOnWebsite',
	gameName: 'gameName',
	architecture: 'architecture'
	// deployedOnApp: 'deployedOnApp' // hiding as not reqd yet
};

export const columnConfigs = [
	NumericalColumn({
		title: 'Version Number',
		mapDataToValue: (data: any) => data[COL_NAMES.versionNumber] || ''
	}),
	StringColumn({
		title: 'Version Name',
		mapDataToValue: (data: any) => data[COL_NAMES.versionName] || ''
	}),
	StringColumn({
		title: 'Architecture',
		mapDataToValue: (data: any) => data[COL_NAMES.architecture] || ''
	}),
	StringColumn({
		title: 'App Package Name',
		mapDataToValue: (data: any) => data[COL_NAMES.appPackageName] || ''
	}),
	StringColumn({
		title: 'Game Name',
		mapDataToValue: (data: any) => data[COL_NAMES.gameName] || ''
	}),
	CustomDateColumn({
		title: 'Updated At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.updatedAt
	}),
	StringColumn({
		title: 'Updated By',
		mapDataToValue: (data: any) => data[COL_NAMES.updatedBy] || ''
	}),
	BooleanColumn({
		title: 'Ever used on Website',
		mapDataToValue: (data: any) => data[COL_NAMES.deployedOnWebsite]
	}),

	StringColumn({
		title: 'Apk Link Url',
		mapDataToValue: (data: any) => data[COL_NAMES.apkLinkUrl] || '',
		minWidth: 600
	})
];
